import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { FlexColumnCenter, SmallBody, ApproveIcon as BaseApproveIcon } from '@ubeya/shared-web/components';
import { ReactComponent as EmployeesIcon } from '@ubeya/shared-web/assets/module-employee.svg';
import { ReactComponent as CalendarIcon } from '@ubeya/shared-web/assets/module-scheduling.svg';
import { ReactComponent as TimesheetIcon } from '@ubeya/shared-web/assets/module-timesheet.svg';
import { ReactComponent as FeedIcon } from '@ubeya/shared-web/assets/module-communication.svg';
import { ReactComponent as DirectoryIcon } from '@ubeya/shared-web/assets/module-directory.svg';
import { ReactComponent as CRMIcon } from '@ubeya/shared-web/assets/module-crm.svg';
import { ReactComponent as PayrollIcon } from '@ubeya/shared-web/assets/module-payroll.svg';
import { ReactComponent as OrderIcon } from '@ubeya/shared-web/assets/module-order.svg';
import { ReactComponent as SequencesIcon } from '@ubeya/shared-web/assets/module-sequences.svg';
import { ReactComponent as ComplianceIcon } from '@ubeya/shared-web/assets/module-compliance.svg';
import { ReactComponent as SuppliersIcon } from '@ubeya/shared-web/assets/module-suppliers.svg';
import { ReactComponent as InvoicesIcon } from '@ubeya/shared-web/assets/module-invoices.svg';
import { ReactComponent as AppStoreIcon } from '@ubeya/shared-web/assets/module-app-store.svg';
import { ReactComponent as HelpDeskIcon } from '@ubeya/shared-web/assets/module-help-desk.svg';
import { ReactComponent as AtsIcon } from '@ubeya/shared-web/assets/module-ats.svg';

const ICONS_MAP = {
  employees: EmployeesIcon,
  onboarding: SequencesIcon,
  training: FeedIcon,
  crm: CRMIcon,
  timesheet: TimesheetIcon,
  payroll: PayrollIcon,
  scheduling: CalendarIcon,
  communication: FeedIcon,
  orders: OrderIcon,
  directory: DirectoryIcon,
  sequences: SequencesIcon,
  compliance: ComplianceIcon,
  suppliers: SuppliersIcon,
  invoice: InvoicesIcon,
  app_store: AppStoreIcon,
  help_desk: HelpDeskIcon,
  ats: AtsIcon
};

const ApproveIcon = styled(BaseApproveIcon)`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 23px;
  height: 23px;
  transition: opacity 200ms;

  circle {
    ${({ $isActive }) =>
      $isActive
        ? css`
            fill: ${({ $color, theme }) => $color || theme.colors.white};
            stroke: ${({ $color, theme }) => $color || theme.colors.white};
          `
        : css`
            stroke: ${({ $color, theme }) => $color || theme.colors.grey2};
          `}
  }
  path {
    fill: ${({ $color, theme }) => $color || theme.colors.grey2};
  }
`;

const Wrapper = styled(FlexColumnCenter)`
  position: relative;
  width: 130px;
  height: 130px;
  border-radius: 8px;

  @media (min-height: 800px) {
    width: 150px;
    height: 150px;
  }

  border: 1px solid
    ${({ theme, isSelected }) => (isSelected ? `${theme.colors.primary}!important` : theme.colors.grey2)};

  transition: transform 200ms;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'no-drop')};

  > svg:first-child {
    margin-bottom: 10px;
  }

  > ${SmallBody} {
    font-size: 14px;
    text-align: center;
    color: ${({ theme, isSelected }) => (isSelected ? theme.colors.primary : theme.colors.black)};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.grey3};
  }
`;

const ModuleBox = ({ label, icon, value, onChange, isDisabled, className }) => {
  const Icon = ICONS_MAP[icon] || icon;
  const { colors } = useTheme();

  return (
    <Wrapper
      isSelected={!!value}
      isDisabled={isDisabled}
      onClick={isDisabled ? undefined : () => onChange(!value)}
      className={className}>
      {Icon && <Icon />}
      <SmallBody>{label}</SmallBody>
      <ApproveIcon $isActive={!!value} $color={value ? colors.primary : colors.grey2} />
    </Wrapper>
  );
};

export default ModuleBox;
